import classNames from 'classnames';
import * as React from 'react';
import isString from 'lodash/isString';
const ListItemCaption = (props) => {
    const { prefix = 'cn-ui-m-', children, className, ...others } = props;
    const newClassName = classNames(`${prefix}list-item-caption`, className);
    return isString(children) ? (React.createElement("span", { ...others, className: newClassName }, children)) : (React.createElement("div", { ...others, className: newClassName }, children));
};
export default ListItemCaption;
